import { defineMessages } from 'react-intl';

export default defineMessages({
  ctaTextNearToExpire: { id: 'gofre.Subscription.Status.near-to-expire.cta' },
  notificationNearToExpire: { id: 'gofre.Subscription.Status.near-to-expire' },
  ctaTextNearToCancel: { id: 'gofre.Subscription.Status.near-to-cancel.cta' },
  notificationNearToCancel: { id: 'gofre.Subscription.Status.near-to-cancel' },
});
